import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgRemoveFormatting = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	strokeWidth: 2,
	strokeLinecap: "round",
	strokeLinejoin: "round",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", { d: "M4 7V4h16v3" }),
		/* @__PURE__ */ _jsx("path", { d: "M5 20h6" }),
		/* @__PURE__ */ _jsx("path", { d: "M13 4 8 20" }),
		/* @__PURE__ */ _jsx("path", { d: "m15 15 5 5" }),
		/* @__PURE__ */ _jsx("path", { d: "m20 15-5 5" })
	]
});
export default SvgRemoveFormatting;
